function isStrongPassword(password: string) {
  const strongRegex: RegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{12,})/;
  return strongRegex.test(password);
}

export {
  isStrongPassword,
};
